import styled from 'styled-components';
import { Flex } from 'UI';

export const ProductImageBackground = styled.div<{ imageBase64?: string }>`
  width: 100%;
  height: 100%;
`;

export const ProductImageUnavailable = styled(Flex)`
  width: 100%;
  height: 100%;
`;
